// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DateUtils = require("../../shared/src/DateUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var StringUtils = require("../../shared/src/StringUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var FormalityCompat = require("re-formality/src/FormalityCompat.bs.js");
var CommonTypes_PhoneNumber = require("../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var CommonTypes_LongPhoneNumber = require("../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");

var Async_Make = FormalityCompat.Async.Make;

var Async_MakeWithId = FormalityCompat.Async.MakeWithId;

var Async_MakeOnBlur = FormalityCompat.Async.MakeOnBlur;

var Async_MakeOnBlurWithId = FormalityCompat.Async.MakeOnBlurWithId;

var Async_debounceInterval = FormalityCompat.Async.debounceInterval;

var Async = {
  Make: Async_Make,
  MakeWithId: Async_MakeWithId,
  MakeOnBlur: Async_MakeOnBlur,
  MakeOnBlurWithId: Async_MakeOnBlurWithId,
  debounceInterval: Async_debounceInterval,
  Strategy: undefined
};

function validInt(param) {
  return Relude_Globals.$great$great(Relude_String.toInt, (function (param) {
                return Relude_Result.fromOption("Must be a valid number", param);
              }), param);
}

function validFloat(param) {
  return Relude_Globals.$great$great(Relude_String.toFloat, (function (param) {
                return Relude_Result.fromOption("Must be a valid number", param);
              }), param);
}

function validPhoneNumber(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(StringUtils.getNumbersOnly, CommonTypes_LongPhoneNumber.fromString, param);
                            }), (function (param) {
                              return Relude_Result.fromOption("Please use format: XXX-XXX-XXXX", param);
                            }), param);
              }), (function (param) {
                return Relude_Result.map(CommonTypes_PhoneNumber.fromLongNumber, param);
              }), param);
}

var partial_arg = Relude_Option.keep(Curry._1(Relude_Int.OrdNamed.greaterThan, 0));

function partial_arg$1(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg, param);
}

function greaterThanZero(param) {
  return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                return Relude_Result.fromOption("Must be greater than 0", param);
              }), param);
}

var partial_arg$2 = Relude_Option.keep(Curry._1(Relude_Int.OrdNamed.greaterThanOrEq, 0));

function partial_arg$3(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg$2, param);
}

function nonNegative(param) {
  return Relude_Globals.$great$great(partial_arg$3, (function (param) {
                return Relude_Result.fromOption("Cannot be negative", param);
              }), param);
}

function nonWhitespace(param) {
  return Relude_Globals.$great$great(Relude_String.toNonWhitespace, (function (param) {
                return Relude_Result.fromOption("Required", param);
              }), param);
}

function todayOrLater(currentDate, date) {
  if (DateUtils.isGreaterThanOrEqualTo(undefined, /* Day */4, currentDate)(date)) {
    return Relude_Result.ok(date);
  } else {
    return Relude_Result.error("Cannot be in the past");
  }
}

function readOnly(param) {
  return Relude_Result.ok(undefined);
}

var Validators = {
  validInt: validInt,
  validFloat: validFloat,
  validPhoneNumber: validPhoneNumber,
  greaterThanZero: greaterThanZero,
  nonNegative: nonNegative,
  nonWhitespace: nonWhitespace,
  todayOrLater: todayOrLater,
  readOnly: readOnly
};

exports.Async = Async;
exports.Validators = Validators;
/* partial_arg Not a pure module */
